import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

import { OrderTypeId } from 'types/order'

import { getDateFromServerDate, getMoscowDate } from 'utils/date'

import { Icon, IconType } from 'components/atoms/Icon'

import classes from './style.module.css'

interface OrderTimerProps {
  orderDate?: string
  orderType?: number | undefined
  timeInMs?: number
  workTimeInMs?: number
  showIcon?: boolean
  prefix?: string
  className?: string
}

export const formatTimeFromMs = (timeInMs: number): { days: number; hours: number; mins: number } => {
  const timeDiff = new Date(timeInMs)
  return {
    days: timeDiff.getUTCDate() - 1,
    hours: timeDiff.getUTCHours(),
    mins: timeDiff.getUTCMinutes(),
  }
}

export const OrderTimer: React.FC<OrderTimerProps> = ({
  orderDate,
  orderType,
  timeInMs,
  workTimeInMs,
  showIcon = true,
  prefix = '',
  className = '',
}) => {
  const [now, setNow] = useState(getMoscowDate())
  const date = orderDate ? getDateFromServerDate(orderDate) : null

  const orderDiff = date ? new Date(now.getTime() - date.getTime()) : null
  const timeDiff = timeInMs ? new Date(timeInMs) : null
  const workTimeDiff = workTimeInMs ? new Date(workTimeInMs) : null

  useEffect(() => {
    if (orderDate) {
      const interval = setInterval(() => {
        setNow(getMoscowDate())
      }, 10000)

      return () => clearInterval(interval)
    }
  }, [orderDate])

  const isTimeExceeded = useCallback((type, dateDiff) => {
    if (dateDiff) {
      if (type === OrderTypeId.DRIVER_DOC_CHECK) return dateDiff.getTime() > 60 * 60 * 1000
      return dateDiff.getTime() > 30 * 60 * 1000
    }
    return false
  }, [])

  const formatTime = (time: Date | null) => {
    if (!time) return null
    const days = time.getUTCDate() - 1
    const hours = time.getUTCHours()
    const mins = time.getUTCMinutes()

    return (
      <>
        {days > 0 ? <>{days}д</> : null}
        {hours > 0 || days > 0 ? <>{hours}ч</> : null}
        {mins}м
      </>
    )
  }

  // Используем timeInMs если передан, иначе orderDiff
  const displayTime = timeInMs ? timeDiff : orderDiff
  if (!displayTime && !workTimeDiff) return null

  const shouldShowDanger = (orderDiff && orderDiff.getTime() > 30 * 60 * 1000) || (workTimeDiff && workTimeDiff.getTime() > 30 * 60 * 1000)

  return (
    <span className={classNames('align-middle d-inline-flex align-items-center', shouldShowDanger ? 'text-danger' : '', className)}>
      {prefix}
      {showIcon && orderDiff && (
        <>
          {isTimeExceeded(orderType, orderDiff) ? <Icon type={IconType.Bell} className={classes.bell} /> : <Icon type={IconType.Time} />}
          &nbsp;
        </>
      )}
      {displayTime && formatTime(displayTime)}
      {workTimeDiff && (
        <>
          &nbsp;/&nbsp;
          {formatTime(workTimeDiff)}
        </>
      )}
    </span>
  )
}

export default OrderTimer
